    <header class="page-head">
      <div>
        <h1 class="page-title">Welcome back, {{ userName() }}</h1>
        <p class="page-subtitle">
          Keep your personal profile, institutions, contacts, and recovery workflows current from one dashboard.
        </p>
      </div>
      <div class="status-chip">
        <i class="fa-solid fa-shield-halved"></i>
        Secure identity profile active
      </div>
    </header>

    <section class="dashboard-grid">
      <a class="dashboard-card panel" routerLink="/contacts">
        <i class="fa-solid fa-phone"></i>
        <div class="card-title">My Contacts</div>
      </a>
      <a class="dashboard-card panel" routerLink="/institutions">
        <i class="fa-solid fa-building-columns"></i>
        <div class="card-title">My Linked Institutions</div>
      </a>
      <a class="dashboard-card panel" routerLink="/billing">
        <i class="fa-brands fa-cc-mastercard"></i>
        <div class="card-title">Billing</div>
      </a>
      <a class="dashboard-card panel" routerLink="/account">
        <i class="fa-solid fa-circle-user"></i>
        <div class="card-title">My Account</div>
      </a>
      <a class="dashboard-card panel" routerLink="/help">
        <i class="fa-solid fa-comments"></i>
        <div class="card-title">Get Help</div>
      </a>
      <a class="dashboard-card panel" routerLink="/services">
        <i class="fa-solid fa-gears"></i>
        <div class="card-title">Other Services</div>
      </a>
    </section>

    <section class="summary-grid summary-grid-spaced-top">
      <div class="stat-card span-4">
        <span class="eyebrow eyebrow-soft">Recovery</span>
        <h3 class="section-title">Number loss response</h3>
        <p class="label">Queue automated updates for banks, insurers, employers, and direct contacts as soon as your number changes.</p>
      </div>
      <div class="stat-card span-4">
        <span class="eyebrow eyebrow-warm">Backup</span>
        <h3 class="section-title">Contacts and messages</h3>
        <p class="label">Keep your contacts, SMS, and future WhatsApp backups ready for recovery to a new device or number.</p>
      </div>
      <div class="stat-card span-4">
        <span class="eyebrow eyebrow-soft">Orders</span>
        <h3 class="section-title">New services</h3>
        <p class="label">Explore add-on products, manage orders, and move directly into checkout when you are ready.</p>
      </div>
    </section>
